module.exports = __webpack_public_path__ + "img/81.fe9fe3c9.jpg";